module.exports = __webpack_public_path__ + "static/media/88.de3453db.jpg";